const COMMUNICATION_SUCCESS = "COMMUNICATION_SUCCESS";

const initialState = {
    CommApiValues: null,
};

const apiCallingReducer = (state = initialState, action) => {
    switch (action.type) {
        case COMMUNICATION_SUCCESS:
            return { ...state, CommApiValues: action.payload };
        default:
            return state;
    }
};

const setCallingData = (payload) => ({ type: COMMUNICATION_SUCCESS, payload });

export { setCallingData, apiCallingReducer };